import { Icon } from "@iconify/react";
import React from "react";
import { useTranslation } from 'react-i18next';
import Map from "../components/Map";

const Footer = () => {
  const { t } = useTranslation();
  const now = new Date();

  const sectionTitleStyle = {
    color: '#c59d5f',
    fontSize: '13px',
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: '2px',
    marginBottom: '25px',
    paddingBottom: '12px',
    borderBottom: '1px solid rgba(197, 157, 95, 0.3)'
  };

  const textStyle = {
    color: '#a0a0a0',
    fontSize: '14px',
    lineHeight: '1.8',
    margin: '0'
  };

  const linkStyle = {
    color: '#a0a0a0',
    textDecoration: 'none',
    transition: 'color 0.3s ease',
    display: 'block',
    marginBottom: '12px',
    fontSize: '14px'
  };

  const navLinks = [
    { to: '/', label: t('nav.home') },
    { to: '/menu', label: t('nav.menu') },
    { to: '/gallery', label: t('nav.gallery') },
    { to: '/events', label: t('nav.events') },
    { to: '/reservations', label: t('nav.reservations') },
    { to: '/contacts', label: t('nav.contacts') }
  ];

  return (
    <>
      <div className="map">
        <div id="map">
          <Map />
        </div>
      </div>

      <footer id="footer" className="dark" style={{ padding: '60px 0 0 0' }}>
        <div className="container">
          <div className="row">
            {/* Coluna 1 - Sobre o Restaurante */}
            <div className="col-md-4 col-sm-6 col-xs-12" style={{ marginBottom: '40px' }}>
              <img
                src="img/logo3.png"
                alt="Fleur de Sel Luxembourg"
                style={{ maxWidth: '160px', marginBottom: '20px' }}
              />
              <p style={{ ...textStyle, marginBottom: '20px', paddingRight: '20px' }}>
                {t('home.welcomeText').substring(0, 150)}...
              </p>

              {/* Redes Sociais */}
              <div style={{ display: 'flex', gap: '12px', marginTop: '20px' }}>
                <a
                  href="https://www.facebook.com/profile.php?id=100063786393603"
                  rel="noreferrer"
                  target="_blank"
                  style={{
                    color: '#fff',
                    backgroundColor: 'rgba(255,255,255,0.1)',
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'all 0.3s ease'
                  }}
                  className="social-icon"
                >
                  <Icon icon="ic:baseline-facebook" width="20px" height="20px" />
                </a>
              </div>
            </div>

            {/* Coluna 2 - Navegação */}
            <div className="col-md-2 col-sm-6 col-xs-6" style={{ marginBottom: '40px' }}>
              <h4 style={sectionTitleStyle}>{t('nav.menu')}</h4>
              {navLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.to}
                  style={linkStyle}
                  className="footer-link"
                >
                  {link.label}
                </a>
              ))}
            </div>

            {/* Coluna 3 - Horários */}
            <div className="col-md-3 col-sm-6 col-xs-6" style={{ marginBottom: '40px' }}>
              <h4 style={sectionTitleStyle}>{t('footer.openingHours')}</h4>

              <p style={{ ...textStyle, marginBottom: '15px', color: '#c59d5f', fontWeight: '500' }}>
                {t('footer.schedule')}
              </p>

              <div style={{ marginBottom: '12px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                  <span style={{ color: '#a0a0a0', fontSize: '14px' }}>{t('footer.lunch')}</span>
                  <span style={{ color: '#fff', fontSize: '14px' }}>{t('footer.lunchHours')}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span style={{ color: '#a0a0a0', fontSize: '14px' }}>{t('footer.dinner')}</span>
                  <span style={{ color: '#fff', fontSize: '14px' }}>{t('footer.dinnerHours')}</span>
                </div>
              </div>

              {/* Botão Reservar */}
              <a
                href="/reservations"
                style={{
                  display: 'inline-block',
                  marginTop: '20px',
                  padding: '12px 25px',
                  backgroundColor: '#c59d5f',
                  color: '#fff',
                  textDecoration: 'none',
                  fontSize: '12px',
                  fontWeight: '600',
                  textTransform: 'uppercase',
                  letterSpacing: '1px',
                  borderRadius: '3px',
                  transition: 'all 0.3s ease'
                }}
                className="btn-reserve"
              >
                {t('home.bookTable')}
              </a>
            </div>

            {/* Coluna 4 - Contactos */}
            <div className="col-md-3 col-sm-6 col-xs-12" style={{ marginBottom: '40px' }}>
              <h4 style={sectionTitleStyle}>{t('nav.contacts')}</h4>

              <div style={{ marginBottom: '20px' }}>
                <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '15px' }}>
                  <Icon icon="mdi:map-marker" width="18px" style={{ color: '#c59d5f', marginRight: '12px', marginTop: '3px', flexShrink: 0 }} />
                  <p style={textStyle}>
                    {t('footer.addressLine')}<br />
                    {t('footer.addressCity')}
                  </p>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                  <Icon icon="mdi:phone" width="18px" style={{ color: '#c59d5f', marginRight: '12px', flexShrink: 0 }} />
                  <a href="tel:+35228371979" style={{ ...linkStyle, marginBottom: 0 }}>
                    (+352) 28 37 19 79
                  </a>
                </div>

                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Icon icon="mdi:email-outline" width="18px" style={{ color: '#c59d5f', marginRight: '12px', flexShrink: 0 }} />
                  <a href="mailto:reservations@fleurdeselrestaurant.lu" style={{ ...linkStyle, marginBottom: 0, fontSize: '13px' }}>
                    reservations@fleurdeselrestaurant.lu
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div style={{
          borderTop: '1px solid rgba(255,255,255,0.1)',
          marginTop: '20px',
          padding: '25px 0',
          backgroundColor: 'rgba(0,0,0,0.2)'
        }}>
          <div className="container">
            <div className="row">
              <div className="col-md-6 col-sm-12 text-left" style={{ marginBottom: '10px' }}>
                <p style={{ color: '#666', fontSize: '13px', margin: 0 }}>
                  © {now.getFullYear()} {t('footer.allRightsReserved')}{' '}
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://fleurdeselrestaurant.lu"
                    style={{ color: '#c59d5f' }}
                  >
                    Fleur de Sel
                  </a>
                </p>
              </div>
              <div className="col-md-6 col-sm-12 text-right">
                <a href="/terms-and-conditions" style={{ color: '#666', fontSize: '13px', textDecoration: 'none' }}>
                  {t('terms.title')}
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>

      <style>{`
        .footer-link:hover {
          color: #c59d5f !important;
          padding-left: 5px;
        }
        .social-icon:hover {
          background-color: #c59d5f !important;
        }
        .btn-reserve:hover {
          background-color: #a88347 !important;
        }
        @media (max-width: 767px) {
          #footer .text-left, #footer .text-right {
            text-align: center !important;
          }
        }
      `}</style>
    </>
  );
};

export default Footer;
